import { render } from "./SAEInfraView.vue?vue&type=template&id=036f1c94&scoped=true&ts=true"
import script from "./SAEInfraView.vue?vue&type=script&lang=ts"
export * from "./SAEInfraView.vue?vue&type=script&lang=ts"

import "./SAEInfraView.vue?vue&type=style&index=0&id=036f1c94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036f1c94"]])

export default __exports__